// ── WEB3FORMS BACKEND ─────────────────────────────────────────────────
// Submissions from the Contact form and the Pre-Qualification page are sent
// to Web3Forms, which forwards them to the email registered against this
// access key in your Web3Forms account (kemcltd@gmail.com).
//
// To change the destination address, update it in the Web3Forms dashboard
// for this access key — the recipient is configured there, not in code.
export const WEB3FORMS_ENDPOINT = 'https://api.web3forms.com/submit'
export const WEB3FORMS_ACCESS_KEY = '4e222fde-5d3f-4dda-9a95-3c5af81d777f'
